import { configureStore, combineReducers } from '@reduxjs/toolkit'
import { createBrowserHistory }  from 'history';
import createSagaMiddleware from 'redux-saga';

import { createReduxHistoryContext, routerReducer, routerMiddleware } from 'redux-first-history';

import serviceConfigsReducer from './services/reducer';
import globalSagas from './global-sagas';

const history = createBrowserHistory();
const sagaMiddleware = createSagaMiddleware();

const { createReduxHistory, routerReducer: myRouterReducer, routerMiddleware: myRouterMiddleware } = createReduxHistoryContext({
  history,
});

const reducer = combineReducers({
    router: myRouterReducer,
    serviceConfigs: serviceConfigsReducer
  });
const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(myRouterMiddleware, sagaMiddleware)
});

sagaMiddleware.run(globalSagas);
const reduxHistory = createReduxHistory(store);
export { store, reduxHistory, history };
